import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import UI from '../../../actions/ui-helper';
import StringUtil from '../../../actions/string';

class ConsultaUsuarioResultado extends Component {
  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  render() {
    if (this.props.resultado.length === 0) {
      return false;
    }
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table key={StringUtil.uuid(5)} id={this.tableId} className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nome</th>
                    <th>E-mail</th>
                    <th>Profissão</th>
                    <th>Perfil</th>
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((usuario, i) => {
                    let situacaoStyle = {
                      borderLeft: '4px solid ' + (usuario.inativo ? 'red' : 'green'),
                    };
                    return (
                      <tr key={usuario.id}>
                        <td style={situacaoStyle}>{usuario.id}</td>
                        <td>{usuario.nome}</td>
                        <td>{usuario.email}</td>
                        <td>{usuario.profissao}</td>
                        <td>
                          <div className="badge badge-default badge-gray badge-xs">
                            {StringUtil.nomePerfil(usuario.perfil)}
                          </div>
                        </td>
                        <td>
                          <div className="dropdown">
                            <button
                              className="btn btn-xs btn-light btn-option icon-btn"
                              type="button"
                              id="dropdownMenuIconButton1"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="fa fa-cog" />
                            </button>
                            <div className="dropdown-menu">
                              <Link
                                to={'/usuario/cadastro/' + usuario.id}
                                className="dropdown-item"
                              >
                                <i className="fa fa-edit" />
                                &nbsp;Editar
                              </Link>
                              {this.props.usuario.perfil === 0 && (
                                <span
                                  onClick={() => this.props.onEmular(usuario, i)}
                                  className="dropdown-item"
                                >
                                  <i className="fa fa-vcard-o" />
                                  &nbsp;Emular usuário
                                </span>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaUsuarioResultado;
